/**
 * General contact request form ("Write to us") — BS-1161.
 *
 * Figma: https://www.figma.com/design/NBnn0MEdCHdbMj2LsWQqng/Consumer-App?node-id=21652-41317
 */
import { createFileRoute } from "@tanstack/react-router";
import { ContactForm } from "~/components/PersonalConsultation/ContactForm";

export const Route = createFileRoute("/$hubMetaName/consultation/contact")({
	beforeLoad: () => {
		document.title = "bacehub | Write to us";
	},
	component: RouteComponent,
});

function RouteComponent() {
	return <ContactForm />;
}
